import { render, staticRenderFns } from "./PageFooterNew.vue?vue&type=template&id=4092dd0e&scoped=true"
import script from "./PageFooterNew.vue?vue&type=script&lang=js"
export * from "./PageFooterNew.vue?vue&type=script&lang=js"
import style0 from "./PageFooterNew.vue?vue&type=style&index=0&id=4092dd0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4092dd0e",
  null
  
)

export default component.exports